var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Navigation'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h4',[_vm._v("Manage Your Subscription")]),_c('div',{staticClass:"row"},[_c('div',{attrs:{"id":"servicebot-subscription-portal"}})])])
}]

export { render, staticRenderFns }